import {
  FgaV1Permission,
  Error as GraphQLErrorResult,
  isError,
} from '@spotify/confidence-graphql';

export const hasRelation = (
  resource:
    | Maybe<{
        resourceRelations?:
          | Maybe<{
              __typename: 'FgaV1ListResourceRelationsResponse';
              resourceRelations?: { relation: string }[];
            }>
          | ({
              __typename: 'Error';
            } & GraphQLErrorResult);
      }>
    | undefined,
  relation: string,
  options?: { localDevGrantAll?: boolean },
): boolean => {
  if (options?.localDevGrantAll && process.env.NODE_ENV === 'development')
    return true;
  if (!resource) return false;
  if (isError(resource?.resourceRelations)) return false;
  return (
    resource?.resourceRelations?.resourceRelations?.some(
      r => r.relation === relation,
    ) ?? false
  );
};

export const getRole = (
  resource: Parameters<typeof hasRelation>[0],
  options?: { localDevGrantAll?: boolean },
): FgaV1Permission => {
  if (hasRelation(resource, 'can_share', options)) return FgaV1Permission.Owner;
  if (hasRelation(resource, 'can_edit', options)) return FgaV1Permission.Editor;
  return FgaV1Permission.Viewer;
};
